var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import responsiveContainerMixin from './responsiveContainerMixin';
/**
 * Use as container with automatic responsive paddings.
 */
export var ModalContent = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  box-sizing: border-box;\n  color: ", ";\n  padding-top: 16px;\n  padding-bottom: 16px;\n\n  @media (min-width: 550px) {\n    padding-top: 24px;\n    padding-bottom: 24px;\n  }\n"], ["\n  ", "\n  box-sizing: border-box;\n  color: ", ";\n  padding-top: 16px;\n  padding-bottom: 16px;\n\n  @media (min-width: 550px) {\n    padding-top: 24px;\n    padding-bottom: 24px;\n  }\n"])), responsiveContainerMixin, cbSemanticCssVars.textPrimary);
var templateObject_1;
//# sourceMappingURL=ModalContent.js.map